import { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import { DataGridPro, GridApiPro, GridRowParams } from "@mui/x-data-grid-pro";
import { Theme } from "klayowebshared";
import { ForwardedRef, forwardRef, MutableRefObject, SyntheticEvent } from "react";
import { Utils } from "../../common/Utils";
import { TableColumnDef } from "../../types/components/table.types";
import { GroupingCellWithLazyLoading } from "../GroupingCellWithLazyLoading";

interface RegulationsTableProps {
  initialRows: any[];
  initialColumns: (columns: TableColumnDef<any>[]) => TableColumnDef<any>[];
  theme?: typeof Theme;
  handleOnRowItemClick?: (
    params: GridRowParams<any>,
    event: SyntheticEvent<Element, Event>
  ) => void;
  showHeader?: boolean;
  hideFirstLastBorder?: boolean;
  sx?: SxProps;
  tableStyle?: string;
}

export const RegulationsTable = forwardRef(
  (props: RegulationsTableProps, ref: ForwardedRef<GridApiPro>) => {
    const {
      initialRows,
      initialColumns,
      theme,
      handleOnRowItemClick,
      showHeader,
      hideFirstLastBorder,
      sx,
      tableStyle
    } = props;

    const tableClass =
      "klayo-table" +
      (showHeader !== false ? " klayo-table--withheader" : "") +
      (hideFirstLastBorder ? " klayo-table--hidefirstlastborder" : "");

    return (
      <Box className={tableClass} sx={sx}>
        <DataGridPro
          sx={{
            "& .MuiDataGrid-virtualScroller": {
              overflow: "hidden"
            },
            "& .MuiDataGrid-row": { cursor: "pointer" },
            "& .MuiDataGrid-cell": {
              display: "flex",
              alignItems: "center",
              lineHeight: "unset"
            }
          }}
          className={
            "klayo-table_grid " +
            (theme ? " klayo-table--breakpoint-" + theme.getCurrentBreakpoint()[0] : "") +
            " " +
            tableStyle
          }
          autoHeight
          treeData
          apiRef={ref as MutableRefObject<GridApiPro>}
          rows={initialRows}
          columns={
            initialColumns([
              {
                type: "name",
                field: "name"
              },
              {
                type: "task",
                field: "task"
              },
              {
                field: "actions",
                type: "actions"
              }
            ]) as any
          }
          getTreeDataPath={Utils.getTreeDataPath}
          groupingColDef={{
            headerName: "",
            width: 48,
            minWidth: 48,
            cellClassName: "klayo-table_expandbuttoncell",
            valueGetter: () => "",
            renderCell: (params) => <GroupingCellWithLazyLoading {...params} />
          }}
          disableChildrenFiltering
          getRowId={Utils.getRowId}
          onRowClick={handleOnRowItemClick}
          columnHeaderHeight={0}
          hideFooterRowCount={true}
          hideFooter={true}
          slots={{
            noRowsOverlay: () => null,
            noResultsOverlay: () => null
          }}
        />
      </Box>
    );
  }
);

RegulationsTable.displayName = "RegulationsTable";
